import { Columns, Column, Icon } from '@codeparva/ui-components-library';
import React from 'react';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { weakKey } from '../../../../utilities/weakKey';
import { FooterTypes } from './footerTypes';
import { getSocialIconsColor } from './helpers/ColorSelectorHelper';
import { footerConstants } from './helpers/constants';
import { useThemeContext } from './hooks/themeContext';

export const FooterSocialMediaIcons = ({
  socialMediaIconsData,
}: FooterTypes.TSocialMediaIcons) => {
  const currTheme = useThemeContext();
  const socialIcons = socialMediaIconsData?.socialIcons;
  const socialIconsColor = getSocialIconsColor(currTheme);
  const { socialIconsBgLightTheme, socialIconsBgDarkTheme } = footerConstants;
  const getSocialMediaIcons = (socialIcons: FooterTypes.TIconsType[]) => {
    const iconsArray: any = [];
    socialIcons.forEach((socialIcon) => {
      iconsArray.push(
        <Icon
          size="medium"
          style={{
            background:
              currTheme === 'light'
                ? `${socialIconsBgLightTheme}`
                : `${socialIconsBgDarkTheme}`,
            paddingRight: '5px',
            borderRadius: '50%',
            padding: '0.0625rem',
            marginRight: '0.5rem',
          }}
          key={weakKey(socialIcon)}
        >
          <a
            href={socialIcon.iconsUrl}
            key={weakKey(socialIcon)}
            target="_blank"
            className="is-flex is-align-items-center"
          >
            <FontAwesomeIcon
              iconClassName={socialIcon.iconName}
              iconContextProps={{
                className: socialIconsColor,
                style: {
                  fontSize: footerConstants.socialIconSize,
                },
              }}
            />
          </a>
        </Icon>
      );
    });
    return iconsArray;
  };
  return (
    <Columns>
      <Column className="socialMediaIcons">
        {socialIcons && <span>{getSocialMediaIcons(socialIcons)}</span>}
        <br />
      </Column>
    </Columns>
  );
};
